import Session from "./Session";

export const areRolesAllowed = (...roles) => {
    return Session.roles.find(role => roles.includes(role.name)) !== undefined;
};